// extracted by mini-css-extract-plugin
module.exports = {"modal":"Slack_modal__1PINI","video":"Slack_video__2y-BI"};